<p-toast position="top-right" styleClass="orders1-toast"></p-toast>
<p-confirmDialog></p-confirmDialog>
<div *ngIf="canAccess">
    <div class="sticky-toolbar mb-3 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template #start>
                <p-button label="New" icon="pi pi-plus" severity="secondary" class="mr-2" (onClick)="openNew()" *ngIf="!isReadOnly" />
                <p-button
                    label="Item lookup"
                    icon="pi pi-search"
                    severity="secondary"
                    class="mr-2"
                    pTooltip="See who bought an item before, or which open orders are still using it"
                    tooltipPosition="top"
                    [routerLink]="['/item-last-sales']"
                />
                <!-- <p-button label="Sales Management" icon="pi pi-plus" severity="secondary" class="mr-2"
                (onClick)="salesManagement()" /> -->
                <!-- <ng-container *ngIf="userService.getDivisionId() === '400'">
                    <p-button *ngIf="isManagerOrSuperUser && !isReadOnly" label="Sync Orders to M3" icon="pi pi-cloud-upload" severity="secondary" class="mr-2" [disabled]="isSyncing" (onClick)="onSyncAllOrders()" />
                </ng-container> -->

                <p-button *ngIf="isManagerOrSuperUser  && !isImmediateDivision" label="Combined Picking list" icon="pi pi-list" severity="secondary" class="mr-2" (onClick)="showCombineDialog = true" />

                <p-button *ngIf="isManagerOrSuperUser" label="Export to Excel" icon="pi pi-file-excel" severity="secondary" class="mr-2" (onClick)="openExportPdfDialog()" />

                <p-button *ngIf="isManagerOrSuperUser" label="AR Statements" icon="pi pi-envelope" severity="secondary" class="mr-2" (onClick)="openARStatementDialog()" />
                <!-- <p-button label="Delete" icon="pi pi-trash" severity="secondary" outlined (onClick)="deleteSelectedProducts()" [disabled]="!selectedProducts || !selectedProducts.length" /> -->
            </ng-template>
 
            <ng-template #end>
                <p-button *ngIf="isManagerOrSuperUser" label="Assign Target" icon="pi pi-bullseye" severity="secondary" class="ml-2" [routerLink]="['/team-details', 1]"> </p-button>
                <p-button *ngIf="isManagerOrSuperUser && !isImmediateDivision" label="Route Wise Picking List" icon="pi pi-cog" severity="secondary" class="mr-2" [routerLink]="['/customize-picking-list']"> </p-button>
                <p-button *ngIf="isManagerOrSuperUser || isSalesPerson" label="Dispute Review" icon="pi pi-comments" severity="secondary" class="mr-2" [routerLink]="['/dispute-review']"> </p-button>
            </ng-template>
        </p-toolbar>
    </div>
    <!-- <div (contextmenu)="onRightClick($event)">Right click here</div> -->
    <p-contextMenu #cm [model]="contextMenuItems"></p-contextMenu>
 
    <div #caption class="flex justify-between items-center flex-wrap gap-2 w-full" style="gap: 10px; padding: 10px; position: sticky; top: 56px; z-index: 3">
     <!-- Left Controls: Date Range, Total Remaining -->
     <div class="flex items-center gap-1 flex-wrap">
        <h5 class="m-0">Manage Orders</h5>
        <div class="flex align-items-center gap-1">
            <p-button
                label="Refresh"
                icon="pi pi-refresh"
                severity="secondary"
                class="mr-2"
                (onClick)="refreshOrders()">
            </p-button>
           

        </div>                
        <p-tag
*ngIf="lastRefreshTime"
value="{{ lastRefreshTime | timeAgo }}"
severity="info"
styleClass="refresh-tag">
</p-tag>


        <p-button label="Load all orders" icon="pi pi-cloud-download" severity="secondary" class="mr-2" (onClick)="loaddata()" />
        <div class="flex align-items-center gap-1">
            <input
                #copyOrderInput
                id="copyFromOrderNumber"
                type="text"
                pInputText
                [(ngModel)]="copyFromOrderNumber"
                name="copyFromOrderNumber"
                placeholder="Copy order no. (10 chars)"
                style="width: 160px"
                maxlength="10"
                autocomplete="off"
                autocapitalize="off"
                autocorrect="off"
                spellcheck="false"
                (input)="onCopyOrderInput($event)"
                (paste)="onCopyOrderPaste($event)"
                (dragover)="onCopyOrderDragOver($event)"
                (drop)="onCopyOrderDrop($event)"
                (keydown.enter)="onCopyOrderEnter($event)"
            />
            <p-button
                icon="pi pi-plus"
                severity="secondary"
                class="mr-2"
                [disabled]="!isValidCopyOrderNumber(copyFromOrderNumber)"
                (onClick)="copyOrderFromInput()"
                pTooltip="Type/drag an order number here, then choose what to copy"
                tooltipPosition="bottom"
            ></p-button>
        </div>
    </div>
        <!-- Right Controls: Action Buttons -->
        <div class="flex items-center gap-1">
            <!-- <button pButton type="button" label="Create Picking List" icon="pi pi-plus" [severity]="'primary'" [disabled]="!selectedOrders.length" class="mr-2" (click)="openDialog()"></button>
                <button pButton type="button" label="Add in Existing Picklist" icon="pi pi-folder" [severity]="'primary'" [disabled]="!selectedOrders.length" (click)="fetchPickingListsByDate()"></button> -->
            <button pButton label="Clear Filters" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt, searchInput)"></button>

            <p-iconfield *ngIf="isDeliverySearchEnabled()">
                <p-inputicon styleClass="pi pi-truck" />
                <input
                    #deliverySearchInput
                    pInputText
                    type="text"
                    [(ngModel)]="deliverySearchTerm"
                    (input)="onDeliveryNumberFilter($event)"
                    (keydown.enter)="onDeliveryNumberEnter($event)"
                    placeholder="Delivery #"
                    style="width: 140px"
                    autocomplete="off"
                    pTooltip="Search Torna orders by M3 delivery number (DLIX)"
                    tooltipPosition="bottom"
                />
            </p-iconfield>
 
            <p-iconfield>
                <p-inputicon styleClass="pi pi-search" />
                <input #searchInput pInputText type="text" [(ngModel)]="globalSearchTerm" (input)="onGlobalFilter(dt, $event)" placeholder="Search..." />
            </p-iconfield>
        </div>
    </div>
 
    <div class="order-table-scroll" style="height: 70vh; position: relative; overflow-y: auto" (scroll)="onTableScroll($event)">
        <p-table
            #dt
            [value]="products()"
            [rows]="pageSize"
            [contextMenu]="cm"
            (onContextMenuSelect)="onRowSelect($event)"
            [(selection)]="selectedProducts"
            [tableStyle]="{ 'min-width': '75rem' }"
            [rowHover]="true"
            dataKey="id"
            [scrollable]="true"
            scrollDirection="horizontal"
            [globalFilterFields]="['orderNumber', 'invoiceNumber', 'type', 'referenceOrderId', 'orderMovingStatus', 'customerName', 'customerId', 'uca2', 'RequestedDate', 'userIdResponsible', 'status', 'address', 'orderType', 'facility', 'warehouse', 'requestedDate']"
            [totalRecords]="totalElements"
            styleClass="order-details-table-sticky"
        >
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th> -->
                    <th pSortableColumn="orderNumber" pFrozenColumn style="min-width: 150px; max-width: 160px">Order Number <p-sortIcon field="orderNumber" /></th>
                    <th pSortableColumn="customerName" style="min-width: 250px; max-width: 350px">Customer <p-sortIcon field="customerName" /></th>
                    <th *ngIf="showDivision100OrderColumns" pSortableColumn="customerId" style="min-width: 110px; max-width: 130px">
                        Cust ID
                        <p-sortIcon field="customerId" />
                    </th>
 
                    <!-- <th  pSortableColumn="referenceOrderId" style="min-width: 180px; max-width: 180px">Reference Order ID <p-sortIcon field="referenceOrderId" /></th> -->
 
                    <!-- <th pSortableColumn="status" style="min-width: 140px; max-width: 300px;">Status <p-sortIcon
                    field="status" /></th> -->

                    <th pSortableColumn="status" style="min-width: 140px; max-width: 320px">
                        Sync Sts
                        <p-sortIcon field="status" />
                        <p-columnFilter type="numeric" field="status" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                    </th>
                    <th pSortableColumn="orderMovingStatus" style="min-width: 115px; max-width: 300px">
                        Moving Sts
                        <p-sortIcon field="orderMovingStatus" />
                        <!-- <p-columnFilter type="numeric" field="MovingStatus" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" /> -->
                    </th>
                    <th pSortableColumn="SyncToM3" [style.min-width]="syncToM3ColumnMinWidth" [style.max-width]="syncToM3ColumnMaxWidth" style="text-align: center">{{ syncToM3ColumnLabel }}</th>
                    <th pSortableColumn="PickList" *ngIf="showPicklistColumn" style="min-width: 80px; max-width: 100px">PickList</th>
                    <th pSortableColumn="Invoice" *ngIf="isManagerOrSuperUser" style="min-width: 80px; max-width: 100px">Invoice</th>
                    <th *ngIf="showDivision100OrderColumns" pSortableColumn="uca2" style="min-width: 120px; max-width: 160px">
                        Extra Info
                        <!-- <p-sortIcon field="uca2" /> -->
                    </th>
                    <th *ngIf="showOrderMarginColumns" style="min-width: 80px; max-width: 90px">Margin %</th>
                    <th *ngIf="showOrderMarginColumns" style="min-width: 70px; max-width: 80px">MCM %</th>
                    <th pSortableColumn="m3LowestStatus" style="min-width: 110px; max-width: 200px">M3 Lo Sts <p-sortIcon field="m3LowestStatus" /></th>
                    <th pSortableColumn="m3HighestStatus" style="min-width: 110px; max-width: 200px">M3 Hi Sts <p-sortIcon field="m3HighestStatus" /></th>

                    <th pSortableColumn="referenceOrderId" style="min-width: 180px; max-width: 180px">
                        Reference Order ID
                        <p-sortIcon field="referenceOrderId" />
                    </th>
                    <th pSortableColumn="invoiceNumber" style="min-width: 170px; max-width: 190px">
                        Invoice Number
                        <p-sortIcon field="invoiceNumber" />
                    </th>
                    <!--
                <th pSortableColumn="RequestedDate" style="min-width: 180px; max-width: 210px">Requested Date
                    <p-sortIcon field="RequestedDate" />
                    <p-columnFilter type="date" field="RequestedDate" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                </th> -->
                    <th pSortableColumn="tornaOrderDateObj" style="min-width: 210px; max-width: 230px">
                        Torna Order Date
                        <p-sortIcon field="tornaOrderDateObj" />
                        <p-columnFilter type="date" field="tornaOrderDateObj" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                    </th>
                    <th pSortableColumn="invoiceDateObj" style="min-width: 180px; max-width: 210px">
                        Invoice Date
                        <p-sortIcon field="invoiceDateObj" />
                        <p-columnFilter type="date" field="invoiceDateObj" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                    </th>
                    <th pSortableColumn="type" style="min-width: 130px; max-width: 150px">Order Type <p-sortIcon field="type" /></th>
                    <th pSortableColumn="category" style="min-width: 110px; max-width: 150px">Facility <p-sortIcon field="category" /></th>
                    <th pSortableColumn="warehouse" style="min-width: 180px; max-width: 210px">
                        Warehouse
                        <p-sortIcon field="warehouse" />
                        <p-columnFilter type="text" field="warehouse" display="menu" placeholder="Filter" [showOperator]="false" [showAddButton]="false" style="width: 100px" />
                    </th>
 
                    <th pSortableColumn="userIdResponsible" style="min-width: 160px; max-width: 180px">
                        User Resp
                        <p-sortIcon field="userIdResponsible" />
                        <p-columnFilter
                            field="userIdResponsible"
                            matchMode="equals"
                            display="menu"
                            [showMatchModes]="false"
                            [showOperator]="false"
                            [showAddButton]="false"
                            style="width: 100px">
                            <ng-template pTemplate="filter">
                                <p-dropdown
                                    [(ngModel)]="selectedUserResponsible"
                                    [options]="salesPersonFilterOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Select salesperson"
                                    [showClear]="true"
                                    [filter]="true"
                                    filterBy="label"
                                    appendTo="body"
                                    (onChange)="onUserResponsibleFilterChange($event.value)"
                                    styleClass="user-resp-filter-dropdown w-full">
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- <th pSortableColumn="Total Articles" style="min-width: 120px; max-width: 150px">Total Articles <p-sortIcon field="Total Articles" /></th> -->
 
                    <th pSortableColumn="grossValue" style="min-width: 120px; max-width: 150px">Gross Value <p-sortIcon field="grossValue" /></th>
                    <th pSortableColumn="totalDiscountValue" style="min-width: 140px; max-width: 150px" *ngIf="division !== '400'">Total Discount <p-sortIcon field="totalDiscountValue" /></th>
                    <th pSortableColumn="netAmount" style="min-width: 130px; max-width: 150px">Net Amount <p-sortIcon field="netAmount" /></th>
                    <th pSortableColumn="vatAmount" style="min-width: 130px; max-width: 150px">VAT Amount <p-sortIcon field="vatAmount" /></th>

                    <th pSortableColumn="totalWeight" style="min-width: 130px; max-width: 150px">Total Weight <p-sortIcon field="totalWeight" /></th>

                    <th pSortableColumn="orderValue" style="min-width: 130px; max-width: 150px">Order Value <p-sortIcon field="orderValue" /></th>
 
                    <!-- <th style="min-width: 120px; max-width: 140px;">Actions</th> -->
                </tr>
            </ng-template>
 
            <ng-template pTemplate="body" let-product>
                <tr
                    [pSelectableRow]="product"
                    [ngClass]="{ 'credit-note-order-row': isCreditNoteOrderRow(product) }"
                    (contextmenu)="onRightClick($event, product)"
                >
                    <!-- <td style="width: rem">
                <p-tableCheckbox [value]="product" />
            </td> -->
                    <td pFrozenColumn>
                        <div class="credit-note-order-cell">
                            <span class="item-name-cell">
                                <a href="#" (click)="onDisplay(product, $event)" class="text-blue-600 hover:underline">
                                    {{ product.orderNumber }}
                                </a>
                                <i
                                    *ngIf="showOrderMarginWarning(product)"
                                    class="pi pi-exclamation-triangle margin-line-badge"
                                    [pTooltip]="getOrderMarginWarningTooltip(product)"
                                    tooltipStyleClass="margin-exception-tooltip-container"
                                    [escape]="false"
                                    tooltipPosition="top"
                                    aria-label="Margin exception"
                                    (click)="$event.stopPropagation(); $event.preventDefault()"
                                ></i>
                            </span>
                            <span *ngIf="isCreditNoteOrderRow(product)" class="credit-note-badge" title="Credit Note Order">
                                <i class="pi pi-file" aria-hidden="true"></i>
                                Credit Note
                            </span>
                        </div>
                    </td>
                    <td>
                        <a href="#" (click)="onDisplay(product, $event)" class="text-blue-600 hover:underline">
                            {{ product.customerName }}
                        </a>
                        <!-- <a [routerLink]="['/item', product.id]" [state]="{ product: product }" class="text-blue-600 hover:underline">
                        {{ product.customerName }}
                    </a> -->
                    </td>
                    <td *ngIf="showDivision100OrderColumns">{{ product.customerId || '-' }}</td>
 
                    <td>
                        <ng-container *ngIf="product.status == 15; else checkStatus90">
                            <span style="display: flex; align-items: center; gap: 0.5em">
                                <span class="p-badge p-badge-warning" style="font-size: 1.1em"> 15 </span>
                                <button type="button" style="background: none; border: none; padding: 0; margin: 0; cursor: pointer" (click)="openErrorSidebar(product); $event.stopPropagation()" title="Click to view error details">
                                    <i
                                        class="pi pi-exclamation-triangle"
                                        style="font-size: 1.5em; color: #ef0f0f; cursor: pointer"
                                    ></i>
                                </button>
                                <button type="button" style="background: none; border: none; padding: 0; margin: 0; cursor: pointer" (click)="onSyncOrder(product); $event.stopPropagation()">
                                    <i class="pi pi-sync" style="font-size: 1.5em; color: #2563eb" title="Sync"></i>
                                </button>
                            </span>
                        </ng-container>
                        <ng-template #checkStatus90>
                            <ng-container *ngIf="product.status == 90 && product.orderMovingStatus === 'CAN'; else normalStatus">
                                <span style="display: flex; align-items: center; gap: 0.5em">
                                    <span class="p-badge p-badge-danger" style="font-size: 1.1em"> 90 </span>
                                    <i class="pi pi-times-circle" style="font-size: 1.5em; color: #dc2626; cursor: pointer" [pTooltip]="getCancellationTooltip(product)" tooltipPosition="top"></i>
                                </span>
                            </ng-container>
                            <ng-template #normalStatus>
                                {{ product.status }}
                            </ng-template>
                        </ng-template>
                    </td>
                    <td>
                    <ng-container [ngSwitch]="(product.orderMovingStatus || '').toUpperCase()">
                        <p-tag *ngSwitchCase="'CRT'" [value]="product.orderMovingStatus" severity="secondary" styleClass="moving-status-tag"></p-tag>
                        <p-tag *ngSwitchCase="'WIP'" [value]="product.orderMovingStatus" severity="warning" styleClass="moving-status-tag"></p-tag>
                        <p-tag *ngSwitchCase="'INV'" [value]="product.orderMovingStatus" severity="success" styleClass="moving-status-tag moving-status-tag-inv" [style]="{'background-color': '#22C55E', 'color': '#fff'}"></p-tag>               
                        <p-tag *ngSwitchCase="'CAN'" [value]="product.orderMovingStatus" severity="danger" styleClass="moving-status-tag" [style]="{'background-color': '#EF4444', 'color': '#fff'}"></p-tag>
                        <p-tag *ngSwitchCase="'PKL'" [value]="product.orderMovingStatus" severity="info" styleClass="moving-status-tag" [style]="{'background-color': '#0EA5E9', 'color': '#fff'}"></p-tag>
                        <span *ngSwitchDefault>{{ product.orderMovingStatus }}</span>
                    </ng-container>
                    </td>
                    <td style="text-align: center; display: flex; justify-content: center; align-items: center; gap: 0">
                        <button 
                            pButton 
                            [icon]="isSyncViewOnly(product) ? 'pi pi-file' : 'pi pi-cloud-upload'" 
                            class="p-button-text p-mr-2" 
                            (click)="onSyncSingleOrder(product); $event.stopPropagation()"
                            [disabled]="isSyncDisabled(product)"
                            [pTooltip]="getSyncTooltip(product)"
                            tooltipPosition="top"
                        ></button>
                        <button
                            pButton
                            icon="pi pi-envelope"
                            class="p-button-text"
                            (click)="openOrderConfirmationMail(product); $event.stopPropagation()"
                            [disabled]="!canSendOrderConfirmationMail(product)"
                            [pTooltip]="getOrderConfirmationMailTooltip(product)"
                            tooltipPosition="top"
                        ></button>
                    </td>
                    <td *ngIf="showPicklistColumn">
                        <button
                            pButton
                            icon="pi pi-print"
                            class="p-button-text p-mr-2"
                            (click)="openPickingList(product.orderNumber, product.customerName); $event.stopPropagation()"
                            [disabled]="isDivision300() && !isFrancePicklistStatusReady(product)"
                            [pTooltip]="getPicklistButtonTooltip(product)"
                            tooltipPosition="top"
                        ></button>
                    </td>
                    <td *ngIf="isManagerOrSuperUser">
                        <button
                            pButton
                            icon="pi pi-print"
                            class="p-button-text p-mr-2"
                            (click)="showInvoiceConfirm(product.orderNumber, product.orderMovingStatus, product.customerName)"
                            [disabled]="isInvoiceDisabled(product)"
                            [pTooltip]="getInvoiceTooltip(product)"
                            tooltipPosition="top"
                        ></button>
                    </td>
                    <td *ngIf="showDivision100OrderColumns">{{ product.uca2 || '-' }}</td>
                    <td *ngIf="showOrderMarginColumns">
                        <ng-container *ngIf="!isCreditNoteOrderRow(product)">
                            <span
                                class="margin-actual-cell"
                                [class.margin-actual--below]="isOrderHeaderMarginBelow(product)"
                                [class.margin-actual--ok]="!isOrderHeaderMarginBelow(product) && hasOrderHeaderMarginValue(product)"
                                [pTooltip]="getOrderHeaderMarginTooltip(product)"
                                tooltipPosition="top"
                            >{{ getOrderMarginPercent(product) }}</span>
                        </ng-container>
                    </td>
                    <td *ngIf="showOrderMarginColumns">
                        <ng-container *ngIf="!isCreditNoteOrderRow(product)">{{ getOrderMcmPercent(product) }}</ng-container>
                    </td>
                    <td>{{ product.m3LowestStatus }}</td>
                    <td>{{ product.m3HighestStatus }}</td>
                    
                    <td>{{ product.referenceOrderId }}</td>
                    <td>{{ product.invoiceNumber || '-' }}</td>
                    <!-- <td>{{ product.requestedDate }}</td> -->
                    <td>
                        {{ product.tornaOrderDateObj | date: 'yyyy-MM-dd' }}
                      </td>
                      <td>
                        {{ product.invoiceDateObj | date: 'yyyy-MM-dd' }}
                      </td>                      
                    <td>{{ product.orderType }}</td>
                    <td>{{ product.facility }}</td>
                    <td>{{ product.warehouse }}</td>
 
                    <td>{{ product.userIdResponsible }}</td>
                    <!-- <td>{{ product.totalArticles }}</td> -->
                    <td>{{ product.grossValue }}</td>
                    <td *ngIf="division !== '400'">{{ product.totalDiscountValue }}</td>
                    <td>{{ product.netAmount }}</td>
                    <td>{{ product.vatAmount }}</td>
                    <td>{{ product.totalWeight }}</td>
                    <td>{{ product.orderValue }}</td>
 
                    <!--  
            <td>
                <p-button  icon="pi pi-fw pi-user-edit" class="mr-2" [outlined]="true"
                    (onClick)="editProduct(product)" />
               <p-button  icon="pi pi-trash" severity="danger" [outlined]="true"
                    (onClick)="deleteProduct(product)" />
             </td> -->
                </tr>
            </ng-template>
        </p-table>
    </div>
    <!-- Dialog for New/Edit -->
    <p-dialog [(visible)]="productDialog" [style]="{ width: '450px' }" header="Order Header" [modal]="true" (onHide)="hideDialog()">
        <ng-template #content>
            <!-- Customer Number -->

            <div class="field mb-4">
                <div class="flex align-items-center justify-content-between gap-2 mb-2" style="width:100%">
                    <label for="customer" class="font-bold m-0">Select Customer</label>
                    <span class="flex align-items-center gap-2 ml-auto">
                        <!-- <span class="text-sm">Normal</span> -->
                        <p-inputSwitch [(ngModel)]="searchLocalException" inputId="searchLocalEx" />
                        <span class="text-sm">Shared Customers</span>
                    </span>
                </div>
                <p-autoComplete
                    [(ngModel)]="selectedCustomer"
                    [suggestions]="customerOptions"
                    (completeMethod)="filterCustomers($event)"
                    field="CUSTOMER"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ minWidth: '520px', maxWidth: 'min(90vw, 720px)' }"
                    panelStyleClass="customer-autocomplete-panel"
                    appendTo="body"
                    (onSelect)="onCustomerSelect($event)"
                    (input)="onCustomerNameInput($event)"
                    [dropdown]="true"
                    [placeholder]="'Select a customer Please enter at least 3 characters'"
                    #customerField
                    (keydown.enter)="focusFacilityInput()"
                ></p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.customer">Customer is required.</small>
            </div>
            <div class="field mb-4">
                <label for="customerNumber" class="block font-bold mb-2">Select Customer Number</label>
                <p-autoComplete
                    [(ngModel)]="selectedCustomerNumber"
                    [suggestions]="customerNumberOptions"
                    (completeMethod)="filterCustomerNumbers($event)"
                    field="CUNO"
                    [style]="{ width: '100%' }"
                    (onSelect)="onCustomerNumberSelect($event)"
                    (input)="onCustomerNumberInput($event)"
                    [dropdown]="true"
                    [placeholder]="'Select a customer number Please enter at least 3 characters'"
                    #customerNumberField
                    (keydown.enter)="focusFacilityInput()"
                ></p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.customer">Customer is required.</small>
            </div>
 
            <!-- Facility -->
            <div class="field mb-4">
                <label for="facility" class="block font-bold mb-2">Facility</label>
                <p-autoComplete
                    inputId="facility"
                    #facilityField
                    [(ngModel)]="product.facilityId"
                    [suggestions]="filteredFacilities"
                    (completeMethod)="filterFacilities($event)"
                    [dropdown]="true"
                    [field]="'label'"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select facility'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    (keydown.enter)="focusWarehouseInput()"
                    appendTo="body"
                    (ngModelChange)="onFacilityChange($event)"
                >
                </p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.facilityId">Facility is required.</small>
            </div>
            <!-- Warehouse -->
            <div class="field mb-4">
                <label for="warehouse" class="block font-bold mb-2">Warehouse</label>
                <p-autoComplete
                    inputId="warehouse"
                    #warehouseField
                    [(ngModel)]="product.warehouseId"
                    [suggestions]="filteredWarehouses"
                    (completeMethod)="filterWarehouses($event)"
                    [dropdown]="true"
                    [field]="'label'"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select warehouse'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    (keydown.enter)="focusOrderTypeInput()"
                    (onSelect)="onWarehouseSelect($event)"
                    appendTo="body"
                >
                </p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.warehouseId">Warehouse is required.</small>
            </div>
 
            <!-- Order Type -->
            <div class="field mb-4">
                <label for="orderType" class="block font-bold mb-2">Order Type</label>
                <p-autoComplete
                    #orderTypeField
                    inputId="orderType"
                    [(ngModel)]="product.orderTypeId"
                    [suggestions]="filteredOrderType"
                    (completeMethod)="filterOrderType($event)"
                    [dropdown]="true"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select Order Type'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    (keydown.enter)="focusAddressInput()"
                    appendTo="body"
                ></p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.orderTypeId">Order Type is required.</small>
            </div>
            <!-- Address: one combobox — pick from list or type a custom address; mode is decided on Proceed -->
            <div class="field mb-4">
                <label for="address" class="block font-bold mb-2">Delivery address</label>
                <p-autoComplete
                    #addressField
                    inputId="address"
                    [(ngModel)]="product.address"
                    (ngModelChange)="onAddressInput($event)"
                    [suggestions]="filteredAddresses"
                    (completeMethod)="filterAddresses($event)"
                    [dropdown]="true"
                    [placeholder]="'Select from list or type a custom address'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="false"
                    appendTo="body"
                    field="label"
                    (onSelect)="onAddressChanged($event)"
                    (keydown.enter)="requestedDateField.focus()"
                ></p-autoComplete>
                <small class="text-surface-500 block mt-1" style="font-size: 12px"
                    >Pick a suggested address or add a new delivery address.</small
                >
            </div>
            <!-- Requested Date -->
            <div>
                <label for="requestedDate" class="block font-bold mb-2">Requested Date</label>
                <input type="date" [min]="today" id="requestedDate" [(ngModel)]="product.requestedDate" required class="border p-2 w-full" #requestedDateField (keydown.enter)="focusSubmitButton()" />
                <small class="text-red-500" *ngIf="submitted && !product.requestedDate">Requested Date is required.</small>
            </div>
        </ng-template>
        
        <ng-template #footer>
            <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
            <button
                pButton
                #submitButton
                label="Proceed"
                icon="pi pi-check"
                (click)="saveProduct()"
                [ngClass]="{ 'p-button-outlined': !isFocused }"
                (focus)="isFocused = true"
                (blur)="isFocused = false"
                (mouseenter)="isFocused = true"
                (mouseleave)="isFocused = false"
            ></button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="customerBlockWarningDialogVisible"
        [modal]="true"
        [style]="{ width: '26rem' }"
        [closable]="true"
        (onHide)="onCustomerBlockWarningCancel()"
    >
        <ng-template pTemplate="header">
            <span class="credit-limit-dialog-header credit-limit-dialog-header--warning">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Customer block warning</span>
            </span>
        </ng-template>
        <div style="font-size: 15px; line-height: 1.45; word-break: break-word;">
            {{ customerBlockWarningMessage }}
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="onCustomerBlockWarningCancel()"></p-button>
            <p-button label="Proceed" icon="pi pi-check" (onClick)="onCustomerBlockWarningProceed()"></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="copyOptionsDialogVisible"
        [style]="{ width: 'min(94vw, 460px)' }"
        [modal]="true"
        [draggable]="false"
        [dismissableMask]="true"
        appendTo="body"
        styleClass="copy-order-options-dialog"
        [closable]="true"
    >
        <ng-template pTemplate="header">
            <div class="copy-order-dialog-header">
                <h2 class="copy-order-dialog-title">Copy order</h2>
                <p class="copy-order-dialog-intro">Select what to bring from the source order.</p>
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="copy-order-options-list" role="radiogroup" aria-label="Copy mode">
                <div
                    class="copy-order-option"
                    [class.copy-order-option--active]="copyModeSelection === 'ALL'"
                    (click)="copyModeSelection = 'ALL'"
                    role="radio"
                    [attr.aria-checked]="copyModeSelection === 'ALL'"
                    tabindex="0"
                    (keydown.enter)="copyModeSelection = 'ALL'"
                    (keydown.space)="$event.preventDefault(); copyModeSelection = 'ALL'"
                >
                    <span class="copy-order-option-icon" aria-hidden="true">
                        <i class="pi pi-file"></i>
                    </span>
                    <div class="copy-order-option-body">
                        <span class="copy-order-option-title">Full copy</span>
                        <span class="copy-order-option-desc"
                            >Header, all lines, quantities and rates. Stock is checked per line.</span
                        >
                    </div>
                    <span class="copy-order-option-check" aria-hidden="true">
                        <i class="pi" [ngClass]="copyModeSelection === 'ALL' ? 'pi-check-circle' : 'pi-circle'"></i>
                    </span>
                    <p-radioButton
                        class="copy-order-option-radio-sr"
                        name="copyMode"
                        inputId="copyModeAll"
                        value="ALL"
                        [(ngModel)]="copyModeSelection"
                        (click)="$event.stopPropagation()"
                    ></p-radioButton>
                </div>
                <div
                    class="copy-order-option"
                    [class.copy-order-option--active]="copyModeSelection === 'HEADER_ITEMS_NO_QTY'"
                    (click)="copyModeSelection = 'HEADER_ITEMS_NO_QTY'"
                    role="radio"
                    [attr.aria-checked]="copyModeSelection === 'HEADER_ITEMS_NO_QTY'"
                    tabindex="0"
                    (keydown.enter)="copyModeSelection = 'HEADER_ITEMS_NO_QTY'"
                    (keydown.space)="$event.preventDefault(); copyModeSelection = 'HEADER_ITEMS_NO_QTY'"
                >
                    <span class="copy-order-option-icon" aria-hidden="true">
                        <i class="pi pi-list"></i>
                    </span>
                    <div class="copy-order-option-body">
                        <span class="copy-order-option-title">Lines without quantities</span>
                        <span class="copy-order-option-desc"
                            >Same header and items. Quantities set to 0. No stock check.</span
                        >
                    </div>
                    <span class="copy-order-option-check" aria-hidden="true">
                        <i
                            class="pi"
                            [ngClass]="copyModeSelection === 'HEADER_ITEMS_NO_QTY' ? 'pi-check-circle' : 'pi-circle'"
                        ></i>
                    </span>
                    <p-radioButton
                        class="copy-order-option-radio-sr"
                        name="copyMode"
                        inputId="copyModeNoQty"
                        value="HEADER_ITEMS_NO_QTY"
                        [(ngModel)]="copyModeSelection"
                        (click)="$event.stopPropagation()"
                    ></p-radioButton>
                </div>
                <div
                    class="copy-order-option"
                    [class.copy-order-option--active]="copyModeSelection === 'HEADER_ITEMS_NO_QTY_NO_RATE'"
                    (click)="copyModeSelection = 'HEADER_ITEMS_NO_QTY_NO_RATE'"
                    role="radio"
                    [attr.aria-checked]="copyModeSelection === 'HEADER_ITEMS_NO_QTY_NO_RATE'"
                    tabindex="0"
                    (keydown.enter)="copyModeSelection = 'HEADER_ITEMS_NO_QTY_NO_RATE'"
                    (keydown.space)="$event.preventDefault(); copyModeSelection = 'HEADER_ITEMS_NO_QTY_NO_RATE'"
                >
                    <span class="copy-order-option-icon" aria-hidden="true">
                        <i class="pi pi-align-left"></i>
                    </span>
                    <div class="copy-order-option-body">
                        <span class="copy-order-option-title">Lines without qty or rate</span>
                        <span class="copy-order-option-desc"
                            >Header and items only. Quantities and rates cleared. Enter values before saving.</span
                        >
                    </div>
                    <span class="copy-order-option-check" aria-hidden="true">
                        <i
                            class="pi"
                            [ngClass]="
                                copyModeSelection === 'HEADER_ITEMS_NO_QTY_NO_RATE' ? 'pi-check-circle' : 'pi-circle'
                            "
                        ></i>
                    </span>
                    <p-radioButton
                        class="copy-order-option-radio-sr"
                        name="copyMode"
                        inputId="copyModeNoQtyRate"
                        value="HEADER_ITEMS_NO_QTY_NO_RATE"
                        [(ngModel)]="copyModeSelection"
                        (click)="$event.stopPropagation()"
                    ></p-radioButton>
                </div>
            </div>

            <div class="copy-order-diff-customer" *ngIf="canShowCopyToDifferentCustomer">
                <div class="copy-order-diff-customer-toggle-row">
                    <p-inputSwitch
                        [ngModel]="copyToDifferentCustomer"
                        (ngModelChange)="onCopyToDifferentCustomerToggle($event)"
                        inputId="copyToDifferentCustomer"
                    ></p-inputSwitch>
                    <div class="copy-order-diff-customer-toggle-text">
                        <label for="copyToDifferentCustomer" class="copy-order-diff-customer-label">
                            Copy to a different customer
                        </label>
                        <p class="copy-order-diff-customer-hint" *ngIf="copyToDifferentCustomer">
                            Rates and discounts are kept from the source order; VAT, margin, stock, and credit are
                            recalculated for the new customer. Facility, warehouse, and order type stay from the source
                            order.
                        </p>
                    </div>
                </div>

                <div class="copy-order-diff-customer-fields" *ngIf="copyToDifferentCustomer">
                    <div class="copy-order-field">
                        <label class="copy-order-field-label" for="copyTargetCustomerName">Customer name</label>
                        <div class="copy-order-field-control">
                            <i class="pi pi-user copy-order-field-icon" aria-hidden="true"></i>
                            <p-autoComplete
                                inputId="copyTargetCustomerName"
                                [(ngModel)]="copyTargetCustomerName"
                                [suggestions]="copyTargetCustomerOptions"
                                (completeMethod)="filterCopyTargetCustomers($event)"
                                field="CUSTOMER"
                                styleClass="copy-order-autocomplete"
                                [fluid]="true"
                                [style]="{ width: '100%' }"
                                [inputStyle]="{ width: '100%' }"
                                appendTo="body"
                                (onSelect)="onCopyTargetCustomerSelect($event)"
                                [dropdown]="true"
                                [placeholder]="'Search or enter at least 3 characters'"
                            ></p-autoComplete>
                        </div>
                    </div>
                    <div class="copy-order-field">
                        <label class="copy-order-field-label" for="copyTargetCustomerNumber">Customer number</label>
                        <div class="copy-order-field-control">
                            <i class="pi pi-tag copy-order-field-icon" aria-hidden="true"></i>
                            <p-autoComplete
                                inputId="copyTargetCustomerNumber"
                                [(ngModel)]="copyTargetCustomerNumber"
                                [suggestions]="copyTargetCustomerNumberOptions"
                                (completeMethod)="filterCopyTargetCustomerNumbers($event)"
                                field="CUNO"
                                styleClass="copy-order-autocomplete"
                                [fluid]="true"
                                [style]="{ width: '100%' }"
                                [inputStyle]="{ width: '100%' }"
                                appendTo="body"
                                (onSelect)="onCopyTargetCustomerNumberSelect($event)"
                                [dropdown]="true"
                                [placeholder]="'Search or enter at least 3 characters'"
                            ></p-autoComplete>
                        </div>
                    </div>
                    <div class="copy-order-field">
                        <label class="copy-order-field-label" for="copyTargetAddress">Delivery address</label>
                        <div class="copy-order-field-control">
                            <i class="pi pi-map-marker copy-order-field-icon" aria-hidden="true"></i>
                            <p-autoComplete
                                inputId="copyTargetAddress"
                                [(ngModel)]="copyTargetAddressText"
                                [suggestions]="copyTargetFilteredAddresses"
                                (completeMethod)="filterCopyTargetAddresses($event)"
                                field="label"
                                styleClass="copy-order-autocomplete"
                                [fluid]="true"
                                [style]="{ width: '100%' }"
                                [inputStyle]="{ width: '100%' }"
                                appendTo="body"
                                (onSelect)="onCopyTargetAddressSelect($event)"
                                [dropdown]="true"
                                [forceSelection]="false"
                                [placeholder]="copyTargetDetailsLoading ? 'Loading addresses…' : 'Select or enter address'"
                                [disabled]="copyTargetDetailsLoading || !copyTargetCustomerId"
                            ></p-autoComplete>
                        </div>
                        <small
                            class="copy-order-field-error"
                            *ngIf="copyToDifferentCustomer && copyTargetCustomerId && !copyTargetAddressText"
                        >
                            Address is required.
                        </small>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="copy-order-dialog-footer">
                <p-button
                    label="Cancel"
                    styleClass="copy-order-btn-cancel"
                    [outlined]="true"
                    severity="secondary"
                    (click)="copyOptionsDialogVisible = false"
                />
                <p-button
                    label="Copy order"
                    icon="pi pi-copy"
                    styleClass="copy-order-btn-primary"
                    (click)="confirmCopyOrder()"
                    [loading]="copyConfirmLoading || copyTargetDetailsLoading"
                    [disabled]="copyConfirmLoading || copyTargetDetailsLoading"
                />
            </div>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="copyTargetBlockWarningDialogVisible"
        [modal]="true"
        [style]="{ width: '450px' }"
        [closable]="true"
        (onHide)="onCopyTargetBlockWarningCancel()"
    >
        <ng-template pTemplate="header">
            <span class="credit-limit-dialog-header credit-limit-dialog-header--warning">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Customer block warning</span>
            </span>
        </ng-template>
        <div style="font-size: 15px; line-height: 1.45; word-break: break-word;">
            {{ copyTargetBlockWarningMessage }}
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="onCopyTargetBlockWarningCancel()"></p-button>
            <p-button label="Proceed" icon="pi pi-check" (onClick)="onCopyTargetBlockWarningProceed()"></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="draftDialogVisible" [style]="{ width: '450px' }" header="Draft Order Found" (onHide)="onDraftDialogHide()" closable="false" [modal]="true" [blockScroll]="true">
        <ng-template #content>
            <div class="text-center">
                <p>We found an unsaved order. Would you like to continue where you left off?</p>
            </div>
        </ng-template>
        <ng-template #footer>
            <p-button label="Discard" icon="pi pi-times" text (click)="discardDraft(); draftDialogVisible = false" />
            <p-button label="Continue" icon="pi pi-check" (click)="continueDraft(); draftDialogVisible = false" />
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="statusHelpDialog" header="Status Help" [modal]="true" [style]="{ width: '350px', maxHeight: '450px' }">
        <div style="font-size: 13px; line-height: 1.6">
            <h6 style="margin: 0 0 8px 0; font-size: 13px">Sync Status</h6>
            <p style="margin: 4px 0"><b>9:</b> The order is kept on hold.</p>
            <p style="margin: 4px 0"><b>10:</b> The order is created and ready to sync in M3.</p>
            <p style="margin: 4px 0"><b>15:</b> There was some error while syncing in M3.</p>
            <p style="margin: 4px 0"><b>20:</b> The order is synced with M3.</p>
            <p style="margin: 4px 0"><b>90:</b> The order is cancelled.</p>

            <h6 style="margin: 12px 0 8px 0; font-size: 13px">M3 Status</h6>
            <p style="margin: 4px 0"><b>22:</b> Reserved</p>
            <p style="margin: 4px 0"><b>33:</b> Allocated selected</p>
            <p style="margin: 4px 0"><b>44:</b> Picking list printed</p>
            <p style="margin: 4px 0"><b>66:</b> Delivered</p>
            <p style="margin: 4px 0"><b>77:</b> Invoiced</p>
            <p style="margin: 4px 0"><b>90:</b> Deleted</p>
            <p style="margin: 4px 0"><b>99:</b> Flagged as completed</p>

            <h6 style="margin: 12px 0 8px 0; font-size: 13px">Moving Status</h6>
            <p style="margin: 4px 0"><b>CRT:</b> Order created</p>
            <p style="margin: 4px 0"><b>PKL:</b> Route wise picking list created</p>
            <p style="margin: 4px 0"><b>WIP:</b> Order syncing to M3</p>
            <p style="margin: 4px 0"><b>INV:</b> Invoice Generated</p>
            <p style="margin: 4px 0"><b>CAN:</b> Order Cancelled in Torna</p>
        </div>
    </p-dialog>
    <app-prepost-text-wizard
        [(visible)]="showTextWizardDialog"
        [textType]="selectedTextType"
        (complete)="onPrePostComplete($event)"
    ></app-prepost-text-wizard>
    <p-dialog header="Combined Picking List Filters" [(visible)]="showCombineDialog" [modal]="true" [style]="{ width: '350px', height: '350px' }">
        <div class="p-fluid">
            <div class="field mb-3" style="display: flex; align-items: center">
                <label for="pickingListType" style="width: 110px; margin-right: 8px">Picking List Type</label>
                <p-dropdown
                    id="pickingListType"
                    [options]="pickingListTypes"
                    [(ngModel)]="combineDialogData.pickingListType"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Type"
                    [style]="{ flex: '1' }"
                    [panelStyle]="{ minWidth: '200px' }"
                ></p-dropdown>
            </div>
            <div class="field mb-3" style="display: flex; align-items: center">
                <label style="width: 110px; margin-right: 8px">From Date</label>
                <input type="date" [(ngModel)]="combineDialogData.fromDate" class="p-inputtext p-component" style="flex: 1" placeholder="YYYY-MM-DD" lang="en-CA" />
            </div>
            <div class="field mb-3" style="display: flex; align-items: center">
                <label style="width: 110px; margin-right: 8px">To Date</label>
                <input type="date" [(ngModel)]="combineDialogData.toDate" class="p-inputtext p-component" style="flex: 1" placeholder="YYYY-MM-DD" lang="en-CA" />
            </div>
            <div class="field mb-3" style="display: flex; align-items: center">
                <label style="width: 110px; margin-right: 8px">Status</label>
                <p-dropdown
                    [options]="orderStatuses"
                    [(ngModel)]="combineDialogData.orderStatus"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Status"
                    [style]="{ flex: '1' }"
                    [panelStyle]="{ minWidth: '200px' }"
                    appendTo="body"
                ></p-dropdown>
            </div>
        </div>
        <ng-template #footer>
            <p-button label="Cancel" icon="pi pi-times" text (click)="showCombineDialog = false"></p-button>
            <p-button label="Proceed" icon="pi pi-check" (click)="onCombinePickingListProceed()"></p-button>
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="sendOrderConfirmationMailVisible" [style]="{ width: '420px' }" header="Send order confirmation" [modal]="true" (onHide)="sendOrderConfirmationMailVisible = false">
        <ng-template pTemplate="content">
            <div class="flex flex-col gap-3">
                <p *ngIf="orderConfirmationMailHasCustomerEmail" class="mb-2">
                    Sending mail to <strong>{{ sendOrderConfirmationMailTo }}</strong>. Please confirm or change the email below.
                </p>
                <p *ngIf="!orderConfirmationMailHasCustomerEmail" class="mb-2">
                    Mail id not found for customer. Please enter email.
                </p>
                <label for="orderConfirmationMailTo">Recipient email</label>
                <input id="orderConfirmationMailTo" type="email" pInputText [(ngModel)]="sendOrderConfirmationMailTo" placeholder="email@example.com" class="w-full" />
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" text (click)="sendOrderConfirmationMailVisible = false"></p-button>
            <p-button label="Send" icon="pi pi-envelope" (click)="sendOrderConfirmationMail()" [loading]="sendOrderConfirmationMailLoading"></p-button>
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="confirmInvoiceDialogVisible" [style]="{ width: '400px' }" header="Confirm Invoice" [modal]="true">
        <ng-template pTemplate="content">
            <div class="text-center">
                <p>
                    Printing invoice will change the order status to <b>INV</b>.<br />
                    Are you sure you want to continue?
                </p>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" text (click)="confirmInvoiceDialogVisible = false"></p-button>
            <p-button label="OK" icon="pi pi-check" (click)="confirmAndGenerateInvoice()" [disabled]="!selectedProductForInvoice || !canGenerateInvoice(selectedProductForInvoice)"></p-button>
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="exportPdfDialogVisible" [modal]="true" header="Export Orders to Excel" [style]="{ width: '340px' }">
        <div class="p-fluid grid gap-3">
            <!-- Quick Monthly Export -->
            <div class="col-12">
                <label class="block font-bold mb-3">Quick Monthly Export</label>
                <div class="flex align-items-center justify-content-center gap-2">
                    <button pButton icon="pi pi-angle-left" (click)="previousMonth()"></button>
                    <p-button [style]="{ width: '200px' }" [loading]="monthExportLoading" (click)="onMonthExport()">
                        <span>{{ selectedMonthName }} {{ selectedYear }}</span>
                    </p-button>
                    <button pButton icon="pi pi-angle-right" (click)="nextMonth()"></button>
                </div>

                <label for="dateFilter" class="block font-bold mb-2 mt-3">Date Filter</label>
                <p-dropdown
                    id="dateFilter"
                    [(ngModel)]="exportDateType"
                    [options]="[
                        { label: 'Order Created Date', value: 'orderCreated' },
                        { label: 'Invoice Date', value: 'invoiceDate' }
                    ]"
                    placeholder="Select date filter"
                    class="w-full"
                ></p-dropdown>

                <label for="exportType" class="block font-bold mb-2 mt-3">Export Type</label>
                <p-dropdown
                    id="exportType"
                    [(ngModel)]="exportExportType"
                    [options]="[
                        { label: 'Order Headers + Lines', value: 'lines' },
                        { label: 'Order Headers Only', value: 'headers' }
                    ]"
                    placeholder="Select export type"
                    class="w-full"
                ></p-dropdown>
            </div>
 
            <!-- Custom Date Range -->
            <div class="col-6">
                <label for="exportFromDate" class="block font-bold mb-2">From Date</label>
                <input type="date" id="exportFromDate" [(ngModel)]="exportFromDate" [min]="'2025-01-01'" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
            </div>
 
            <div class="col-6">
                <label for="exportToDate" class="block font-bold mb-2">To Date</label>
                <input type="date" id="exportToDate" [(ngModel)]="exportToDate" [min]="'2025-01-01'" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
            </div>
        </div>
 
        <ng-template #footer>
            <p-button label="Cancel" icon="pi pi-times" text (click)="exportPdfDialogVisible = false"></p-button>
            <p-button label="Export" icon="pi pi-file-excel" [loading]="customExportLoading" (click)="onExportPdf()"></p-button>
        </ng-template>
    </p-dialog>
 
    <!-- <p-dialog [(visible)]="exportPdfDialogVisible" [modal]="true" header="Export Orders to Excel" [style]="{ width: '300px' }">
    <div class="p-fluid grid gap-3">
        From Date
        <div class="col-6">
            <label for="exportFromDate" class="block font-bold mb-2">From Date</label>
            <input type="date" id="exportFromDate" [(ngModel)]="exportFromDate" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
        </div>
 
        To Date
        <div class="col-6">
            <label for="exportToDate" class="block font-bold mb-2">To Date</label>
            <input type="date" id="exportToDate" [(ngModel)]="exportToDate" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
        </div>
    </div>
 
    <ng-template #footer>
        <p-button label="Cancel" icon="pi pi-times" text (click)="exportPdfDialogVisible = false"></p-button>
        <p-button label="Export" icon="pi pi-file-excel" [loading]="exportPdfLoading" (click)="onExportPdf()"></p-button>
    </ng-template>
</p-dialog> -->
    <!-- Example for facility dropdown -->
    <!-- <p-dropdown
    [options]="filteredFacilities"
    [(ngModel)]="product.facilityId"
    [disabled]="facilityLoading">
</p-dropdown>
<p-progressSpinner *ngIf="facilityLoading" styleClass="facility-loader" [style]="{width: '30px', height: '30px'}"></p-progressSpinner> -->
</div>
<p-dialog [(visible)]="isSyncDialogVisible" [modal]="true" header="Sync Orders" [style]="{ width: '350px' }">
    <ng-template pTemplate="content">
        <div class="text-center">
            <p style="font-size: 16px; line-height: 1.5">
                🟢 Order syncing to M3 has been started.<br />
                Once syncing is complete, a notification will be sent to the respective mail ID.<br />
                You can continue your further work.
            </p>
        </div>
    </ng-template>
</p-dialog>
<!-- Cancel Order Confirmation Dialog -->
<p-dialog [(visible)]="cancelOrderDialogVisible" [style]="{ width: '400px' }" header="Cancel Order" [modal]="true" [closable]="true">
    <ng-template pTemplate="content">
        <p>Do you want to continue with order cancellation?</p>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="No" icon="pi pi-times" (click)="cancelCancelOrder()" severity="secondary"></p-button>
        <p-button label="Yes" icon="pi pi-check" (click)="confirmCancelOrder()" severity="danger"></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="deleteStatus15DialogVisible"
    header="Cancel Order"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    styleClass="status15-cancel-dialog"
    [style]="{ width: '400px' }"
    (onHide)="cancelDeleteStatus15Order()">
    <ng-template pTemplate="content">
        <p class="status15-cancel-dialog-message">
            {{ status15CancelDialogMessage }}
        </p>
    </ng-template>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="status15CreatedInOis300; else status15CancelConfirmButtons">
            <p-button label="OK" icon="pi pi-check" (click)="cancelDeleteStatus15Order()"></p-button>
        </ng-container>
        <ng-template #status15CancelConfirmButtons>
            <p-button label="No" icon="pi pi-times" (click)="cancelDeleteStatus15Order()" severity="secondary"></p-button>
            <p-button label="Yes" icon="pi pi-check" (click)="confirmDeleteStatus15Order()" severity="danger"></p-button>
        </ng-template>
    </ng-template>
</p-dialog>
 
<!-- Cancellation Reason Dialog -->
<p-dialog [(visible)]="cancellationReasonDialogVisible" [style]="{ width: '450px' }" header="Cancellation Reason" [modal]="true" [closable]="true">
    <ng-template pTemplate="content">
        <div class="flex flex-column gap-2">
            <label for="cancellationReason">Cancellation Reason <span class="text-red-500">*</span></label>
            <textarea id="cancellationReason" pInputTextarea [(ngModel)]="cancellationReason" rows="4" [autoResize]="true" placeholder="Enter cancellation reason..." style="width: 100%"> </textarea>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" (click)="closeCancellationReasonDialog()" severity="secondary"></p-button>
        <p-button label="Submit" icon="pi pi-check" (click)="submitCancellation()" [disabled]="!cancellationReason || cancellationReason.trim() === ''"></p-button>
    </ng-template>
</p-dialog>
<p-dialog
    header="Sync in progress"
    [(visible)]="syncConflictVisible"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '400px' }"
    (onHide)="closeSyncConflictDialog()">
    <p>Sync already in progress. Please wait and try again later.</p>
    <ng-template pTemplate="footer">
        <p-button label="OK" (onClick)="closeSyncConflictDialog()"></p-button>
    </ng-template>
</p-dialog>

<app-ar-statement-form
    [(visible)]="customerDialogVisible"
    (submitAR)="handleARSubmit($event)">
</app-ar-statement-form>

<!-- Error Message Sidebar -->
<p-sidebar [(visible)]="sidebarVisible2" position="right" [showCloseIcon]="true" [modal]="true">
    <ng-template pTemplate="header">
        <span class="font-bold">Error Details</span>
    </ng-template>
    <div style="padding: 15px; line-height: 1.6">
        <p style="margin: 0; white-space: pre-wrap; word-break: break-word">{{ errorSidebarMessage }}</p>
    </div>
</p-sidebar>

<p-dialog
    [(visible)]="creditLimitProceedDialogVisible"
    [modal]="true"
    [style]="{ width: '26rem' }"
    styleClass="credit-limit-dialog"
    [closable]="true"
    (onHide)="onCreditLimitProceedCancel()"
>
    <ng-template pTemplate="header">
        <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Balance</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit 3 &amp; 4 Exceeded</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--warning">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span>Credit Limit Warning</span>
        </span>
    </ng-template>
    <app-credit-limit-dialog-content
        [kind]="creditLimitDialogKind"
        [data]="creditLimitDialogData"
        [nood]="creditLimitDialogNood"
        [odud]="creditLimitDialogOdud"
        [note]="creditLimitProceedNote"
    ></app-credit-limit-dialog-content>
    <div *ngIf="creditLimitProceedNeedsApi" class="credit-limit-approval-reason mt-3">
        <label for="ordersCreditLimitApprovalReason" class="block mb-2 font-medium">Approval reason (required)</label>
        <textarea
            id="ordersCreditLimitApprovalReason"
            pTextarea
            rows="3"
            class="w-full"
            [(ngModel)]="creditLimitApprovalReason"
            [disabled]="creditLimitApprovalSubmitting"
            placeholder="Enter reason for releasing credit restriction"
        ></textarea>
        <small class="text-color-secondary">Minimum 5 characters.</small>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [disabled]="creditLimitApprovalSubmitting" (onClick)="onCreditLimitProceedCancel()"></p-button>
        <p-button
            [label]="creditLimitProceedNeedsApi ? 'Approve &amp; Continue' : creditLimitProceedLabel"
            icon="pi pi-arrow-right"
            [loading]="creditLimitApprovalSubmitting"
            [disabled]="creditLimitProceedNeedsApi && !canSubmitCreditLimitApproval"
            (onClick)="onCreditLimitProceedAccept()"
        ></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="creditLimitBlockedDialogVisible"
    [modal]="true"
    [style]="{ width: '26rem' }"
    styleClass="credit-limit-dialog"
    [closable]="true"
    (onHide)="onCreditLimitBlockedDialogClose()"
>
    <ng-template pTemplate="header">
        <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Balance</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit 3 &amp; 4 Exceeded</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit Exceeded</span>
        </span>
    </ng-template>
    <app-credit-limit-dialog-content
        [kind]="creditLimitDialogKind"
        [data]="creditLimitDialogData"
        [nood]="creditLimitDialogNood"
        [odud]="creditLimitDialogOdud"
        [note]="creditLimitBlockedNote"
    ></app-credit-limit-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" (onClick)="onCreditLimitBlockedDialogClose()"></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="marginApprovalProceedDialogVisible"
    [modal]="true"
    [style]="{ width: '440px', maxWidth: '95vw' }"
    styleClass="margin-validation-dialog margin-approval-dialog"
    [closable]="true"
    (onHide)="onMarginApprovalProceedCancel()"
>
    <ng-template pTemplate="header">
        <span class="margin-dialog-header">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Margin Approval Required</span>
        </span>
    </ng-template>
    <app-margin-approval-dialog-content
        mode="approval"
        [failingLines]="marginApprovalSummary?.failingLines ?? []"
        [orderViolation]="marginApprovalSummary?.orderViolation ?? null"
        [note]="marginApprovalContactNote"
        [contactEmails]="marginApprovalContactEmails"
        [proceedActionLabel]="marginApprovalProceedLabel"
        [proceedNote]="marginApprovalProceedNote"
    ></app-margin-approval-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="onMarginApprovalProceedCancel()"></p-button>
        <p-button [label]="marginApprovalProceedLabel" icon="pi pi-check" styleClass="margin-dialog-ok-btn" (onClick)="onMarginApprovalProceedAccept()"></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="marginApprovalBlockedDialogVisible"
    [modal]="true"
    [style]="{ width: '440px', maxWidth: '95vw' }"
    styleClass="margin-validation-dialog margin-blocked-approval-dialog"
    [closable]="true"
    (onHide)="onMarginApprovalBlockedDialogDismiss()"
>
    <ng-template pTemplate="header">
        <span class="margin-dialog-header">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Approval Required</span>
        </span>
    </ng-template>
    <app-margin-approval-dialog-content
        mode="blocked"
        [failingLines]="marginApprovalSummary?.failingLines ?? []"
        [orderViolation]="marginApprovalSummary?.orderViolation ?? null"
        [note]="marginApprovalContactNote"
        [contactEmails]="marginApprovalContactEmails"
        [blockedApprovalNotice]="marginApprovalBlockedNotice"
    ></app-margin-approval-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" styleClass="margin-dialog-ok-btn" (onClick)="onMarginApprovalBlockedDialogOk()"></p-button>
    </ng-template>
</p-dialog>
